import React from "react";
import {
  FormGroup,
  Label,
  Input,
  InputGroup,
  Button,
  Spinner,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { formatCurrency, formatCrypto } from "../utils/operationsUtils";

// AIDEV-NOTE: Sub-operation search form component with proper display formatting (no NumericFormat for display)
const SubOperationSearchForm = ({
  searchTerm,
  setSearchTerm,
  availableSubOps,
  selectedSubOps,
  loadingSubOps,
  currentPage,
  totalPages,
  setCurrentPage,
  moeda,
  handleSelectSubOperation,
  handleAddSelectedSubOperations,
  fetchAvailableSubOps,
  setViewMode,
}) => {
  const handleSearch = () => {
    setCurrentPage(1);
    fetchAvailableSubOps();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const isSubOpSelected = (operacao) => {
    return selectedSubOps.some(s => s.id === operacao.id);
  };

  return (
    <div>
      <h6 className="mb-3">Buscar Operações Existentes</h6>
      
      {/* Campo de busca */}
      <FormGroup>
        <Label>Buscar por cliente</Label>
        <InputGroup>
          <div className="input-group-text">
            <FeatherIcon icon="search" size={14} />
          </div>
          <Input
            type="text"
            placeholder="Digite o nome do cliente..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <Button
            color="primary"
            onClick={handleSearch}
          >
            Buscar
          </Button>
        </InputGroup>
      </FormGroup>

      {/* Lista de sub-operações disponíveis */}
      {loadingSubOps ? (
        <div className="text-center py-4">
          <Spinner size="sm" />
          <p className="text-muted mt-2 mb-0">Buscando...</p>
        </div>
      ) : availableSubOps.length === 0 ? (
                 <div className="text-center py-4 text-muted">
           <FeatherIcon icon="search" size={32} className="mb-2" />
           <p>Nenhuma operação disponível encontrada</p>
           <small>Tente ajustar o termo de busca</small>
         </div>
      ) : (
        <>
                     <div className="mb-3" style={{ maxHeight: "300px", overflowY: "auto" }}>
             {availableSubOps.map((operacao) => {
               const isSelected = isSubOpSelected(operacao);
              
              return (
                                 <div 
                   key={operacao.id}
                   className={`border rounded p-3 mb-2 cursor-pointer ${
                     isSelected ? 'border-primary bg-light' : ''
                   }`}
                   onClick={() => handleSelectSubOperation(operacao)}
                   style={{ cursor: "pointer" }}
                 >
                   <div className="d-flex justify-content-between align-items-start">
                     <div className="flex-grow-1">
                       <h6 className="mb-1 text-primary">{operacao.user?.name || "N/A"}</h6>
                       <div className="small text-muted mb-1">
                         <strong>Quantidade:</strong> 
                         {moeda?.data?.moeda === "BRL"
                           ? formatCurrency(operacao.quantidade)
                           : formatCrypto(operacao.quantidade, moeda?.data?.moeda)}
                       </div>
                       <div className="small text-muted mb-1">
                         <strong>Cotação:</strong> 
                         {formatCurrency(operacao.cotacao)}
                       </div>
                       <div className="small text-muted mb-1">
                         <strong>Lucro Fort:</strong> 
                         {formatCurrency(operacao.taxa_fort)}
                       </div>
                       <div className="small text-muted">
                         <strong>Total BRL:</strong> 
                         {formatCurrency(operacao.total_brl)}
                       </div>
                     </div>
                    <div className="form-check">
                      <Input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {}}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Botões de ação */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              {selectedSubOps.length > 0 && (
                <small className="text-muted">
                  {selectedSubOps.length} sub-operação(ões) selecionada(s)
                </small>
              )}
            </div>
            <div className="d-flex gap-2">
              <Button
                color="secondary"
                size="sm"
                onClick={() => setViewMode("list")}
              >
                Cancelar
              </Button>
              {selectedSubOps.length > 0 && (
                <Button
                  color="primary"
                  size="sm"
                  onClick={handleAddSelectedSubOperations}
                >
                  <FeatherIcon icon="plus" className="me-1" size={14} />
                  Adicionar ({selectedSubOps.length})
                </Button>
              )}
            </div>
          </div>

          {/* Paginação */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center">
              <div className="d-flex gap-1 align-items-center">
                <Button
                  color="outline-secondary"
                  size="sm"
                  disabled={currentPage === 1}
                  onClick={() => {
                    setCurrentPage(prev => prev - 1);
                  }}
                >
                  <FeatherIcon icon="chevron-left" size={14} />
                </Button>
                
                <span className="px-3 small">
                  {currentPage} de {totalPages}
                </span>
                
                <Button
                  color="outline-secondary"
                  size="sm"
                  disabled={currentPage === totalPages}
                  onClick={() => {
                    setCurrentPage(prev => prev + 1);
                  }}
                >
                  <FeatherIcon icon="chevron-right" size={14} />
                </Button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SubOperationSearchForm; 